import axios from 'axios'

export const refreshToken = async (isOriginal = false) => {
  try {
    const { data } = await axios.post('/api/users/auth/refresh', null, {
      params: {
        isOriginal,
      },
    })

    return data
  } catch (error) {
    console.error('Error refreshing token:', error)

    throw error
  }
}
